if (!customElements.get('bwr-bestsellers')) {
  customElements.define('bwr-bestsellers', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      this.controller = new AbortController();
      this.load();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.loaded = false;
    }

    async load() {
      const status = this.querySelector('[role="status"]');
      status.hidden = false;
      try {
        const response = await fetch(this.dataset.url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Collection unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const list = doc.querySelector('.bwr-sidebar__records');
        if (!list) throw new Error('Collection list unavailable');
        let count = 0;
        list.querySelectorAll('[data-record-id]').forEach(item => {
          if (item.dataset.recordId === this.dataset.productId || count >= 5) {
            item.remove();
          } else {
            count += 1;
            const form = item.querySelector('form');
            if (form) form.id = `BwrBuy-${this.dataset.productId}-${item.dataset.recordId}`;
          }
        });
        this.querySelector('.bwr-sidebar__results').replaceChildren(list);
      } catch (error) {
        if (error.name === 'AbortError') return;
      } finally {
        status.hidden = true;
      }
    }
  });
}

if (!window.bwrBuyNowReady) {
  window.bwrBuyNowReady = true;
  document.addEventListener('submit', event => {
    if (event.submitter?.matches('[data-bwr-buy-now]')) {
      event.stopImmediatePropagation();
    }
  }, true);
}
